import { API } from "../../api";
async function issueVoucher(request) {
    const url = process.env.LETS_TRADE_PRODUCT_URL ?? "";
    return (await new API().apiPost({
        baseUrl: url,
        endpoint: `v2/issue/voucher`,
        content: request,
    }));
}
export { issueVoucher };
